<template>
  <div>
    <div class="flex mb-4" style="align-items: center;">
      <h5>안전이슈</h5>
      <vs-spacer></vs-spacer>
      <vs-button color="secondary" @click="showApproval">결재 프로세스</vs-button>
    </div>
    <div style="margin-left:-1.2rem; margin-right:-1.2rem; padding:1.2rem; background: #fff;">
      <div class="flex mb-8" >
        <vs-button class="w-1/2 mr-2" color="secondary" type="border" @click="back">목록</vs-button>
        <vs-button class="w-1/2 ml-2" color="secondary" v-if="board.savable" @click="handleClickUpdate">임시저장</vs-button>
        <vs-button v-if="board.resend" class="w-1/2 ml-2" color="secondary" @click="handleClickRegister">임시저장 후 재상신</vs-button>
      </div>

      <!-- 기본정보 -->
      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>
      <vs-col class="flex flex-wrap">

        <vs-row class="w-full  mb-4 grid" style="grid-template-columns: 70px 1fr;" vs-align="center">
          <vs-col class="title">사무소명</vs-col>
          <vs-col >
            <vs-input class="w-full" :value="projectInfo.field_name" :readonly="true"/>
          </vs-col>
        </vs-row>

        <vs-row class="w-full  mb-4 grid" style="grid-template-columns: 70px 1fr;" vs-align="center">
          <vs-col class="title">소속</vs-col>
          <vs-col >
            <vs-input class="w-full" v-model="form.company" :readonly="true"/>
          </vs-col>
        </vs-row>

        <vs-row class="w-full  mb-4 grid" style="grid-template-columns: 70px 1fr;" vs-align="center">
          <vs-col class="title">작성자</vs-col>
          <vs-col >
            <vs-input class="w-full" v-model="form.writer" :readonly="true"/>
          </vs-col>
        </vs-row>


        <vs-row class="w-full  mb-4 grid" style="grid-template-columns: 70px 1fr;" vs-align="center">
          <vs-col class="title">발생구분</vs-col>
          <vs-col >
            <vs-select autocomplete class="w-full" v-model="form.occur_type">
              <vs-select-item value="occur_type_1" text="대기"/>
              <vs-select-item value="occur_type_2" text="수질"/>
              <vs-select-item value="occur_type_3" text="폐기물"/>
              <vs-select-item value="occur_type_4" text="소음"/>
              <vs-select-item value="occur_type_5" text="진동"/>
              <vs-select-item value="occur_type_6" text="토양"/>
              <vs-select-item value="occur_type_7" text="기타"/>
            </vs-select>
          </vs-col>
        </vs-row>

        <vs-row class="w-full  mb-4 grid" style="grid-template-columns: 70px 1fr;" vs-align="center">
          <vs-col class="title">발생일</vs-col>
          <vs-col >
            <date-selector class="w-full" v-model="form.occur_date"></date-selector>
          </vs-col>
        </vs-row>

        <vs-row class="w-full  mb-4 grid" style="grid-template-columns: 70px 1fr;" vs-align="center">
          <vs-col class="title">조치일</vs-col>
          <vs-col >
            <date-selector class="w-full" v-model="form.action_date"></date-selector>
          </vs-col>
        </vs-row>

        <vs-row class="w-full  mb-4 flex" vs-align="center">
          <vs-col class="w-full title mb-4">시정 및 예방조치 요구사항</vs-col>
          <vs-col class="w-full">
            <vs-textarea class="w-full" v-model="form.require" :rows="5"/>
          </vs-col>
        </vs-row>
      </vs-col>

      <!-- 시정 및 예방근로자의견 -->
      <vs-row class="mb-4">
        <vs-col>
          <h5><i class="dot"></i>시정 및 예방근로자의견</h5>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col class="w-1/2 pr-1" vs-align="center">
          <vs-button class="w-full" color="secondary" type="border" @click="handleClickAddEval">+ 항목추가</vs-button>
        </vs-col>
        <vs-col class="w-1/2 pl-1" >
          <vs-button class="w-full" color="secondary" type="border" @click="handleClickRemoveEval">- 항목삭제</vs-button>
        </vs-col>
        <vs-col v-if="board.statusCode === 'approved'" class="w-1/2 ml-auto pl-1 mt-2" >
          <vs-button class="w-full" color="secondary" @click="handleClickAfterData">저장</vs-button>
        </vs-col>
      </vs-row>

      <vs-row class="mb-8">
        <vs-col class="p-0 m-0">
          <ul class="table w-full">
            <li class="tbody" v-for="(item, index) in form.actionList" :key="index" style="display: block">
              <vs-col class="flex" style="padding:12px 1.25rem; background-color: #fafafa; border-top:1px solid #cdcdcd; border-bottom:1px solid #cdcdcd;">
                <vs-checkbox v-model="item.is_checked"></vs-checkbox>
                <vs-spacer></vs-spacer>
                <div style="display: flex; align-items: center; justify-content: center; padding:8px; transition: all .3s ease;"
                     :style="item.is_hidden ? '-webkit-transform: rotate(180deg);' : ''">
                  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.41 7.41016L6 2.83016L10.59 7.41016L12 6.00016L6 0.000156403L0 6.00016L1.41 7.41016Z" fill="black"/>
                  </svg>
                </div>
              </vs-col>
              <p class="p-4">
                <vs-row class="border-bottom py-4">
                  <vs-col class="w-full grid" style="grid-template-columns: 110px 1fr;">
                    <vs-col class="h-full flex title" style="align-items: center">시정 및 예방 내용</vs-col>
                    <vs-col ><vs-textarea class="w-full m-0 p-0" v-model="item.actionContent"/></vs-col>
                  </vs-col>
                </vs-row>
                <vs-row class="pt-4" >
                  <vs-col class="w-full grid" style="grid-template-columns: 110px 1fr;">
                    <vs-col class="h-full flex title" style="align-items: center">조치 전 (사진)</vs-col>
                    <vs-col ><file-uploader v-model="item.before"/></vs-col>
                  </vs-col>
                </vs-row>
              </p>

              <p v-if="after[index]" class="p-4">
                <vs-row class="border-bottom py-4">
                  <vs-col class="w-full grid" style="grid-template-columns: 110px 1fr;">
                    <vs-col class="w-full h-full flex title " style="align-items: center">근로자의견</vs-col>
                    <vs-col class="w-full"><vs-textarea class="w-full m-0 p-0" v-model="after[index].text" :readonly="board.statusCode !== 'approved'"/></vs-col>
                  </vs-col>
                </vs-row>
                <vs-row class="pt-4" >
                  <vs-col class="w-full grid" style="grid-template-columns: 110px 1fr;">
                    <vs-col class="w-full h-full flex title " style="align-items: center">조치 후 (사진)</vs-col>
                    <vs-col class="w-full"><file-uploader v-model="after[index].attach" :readonly="board.statusCode !== 'approved'"/></vs-col>
                  </vs-col>
                </vs-row>
              </p>
            </li>
          </ul>
        </vs-col>
      </vs-row>

    </div>
    <vs-row :class="isShowApproval?'':'hidden'" style="position:fixed; top:0; left:0; bottom:0; right:0; z-index:45000; background: rgba(0,0,0,0.7); ">
      <div style="position: relative; width: 100%; height:100%; display: grid; grid-template-rows: 110px; minmax(0%,100%); overflow-y: auto;">
        <vs-spacer @click="hideApproval"></vs-spacer>
        <approval-process-module
          :board = "board"
          :commentabled="!(board.isCompleteApproval || board.savable)"

          @handleClickUpload="handleClickUpload"
          @handleSendApprovalProcess = "handleSendApprovalProcess"
        ></approval-process-module>
        <a style="width:33px; height:33px; position:absolute; top:77px; right:10px;"  @click="hideApproval">
          <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="background: rgb(255, 255, 255);">close</i>
        </a>
      </div>

    </vs-row>

    <!-- 첨부파일 -->
    <file-upload-module class="w-full" :isShowTitle="true" type="check_list_col" v-model="fileList"></file-upload-module>

    <!-- TODO : 얼럿데이터 -->
    <popup-alert v-model="alert.show"
                 :is-confirm="alert.isConfirm"
                 :html="alert.html"
                 :message="alert.message"
                 :buttons="alert.buttons"

                 @upload="alertUpload"
                 @ok="alertOk"
                 @no="alertNo"
    ></popup-alert>
  </div>
</template>

<script>
import DateSelector from '@/views/components/DateSelector'
import FileUploader from '@/views/components/FileUploader'
import ApprovalProcessModule from '@/views/modules/ApprovalProcessModule'
import PopupAlert from '@/views/components/popup/PopupAlert'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  name: 'MobilePreventionSafetyRequestUpdate',
  components: {
    FileUploadModule,
    PopupAlert,
    ApprovalProcessModule,
    FileUploader,
    DateSelector},
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    }
  },
  data () {
    return {
      boardId:36,
      boardSlug: 'safety_request',

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug:'safety_request',
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        collection: true, // 문서 회수가 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine:[], // 결재라인
        commentList:[] // 댓글리스트
      },
      approvalLine: [], // 현재 결재선, api 전송용

      // TODO : 얼럿데이터
      alert: {
        show: false,
        isConfirm: false,
        html: '',
        message: '결재하시겠습니까?',
        buttons: [
          {
            label: '승인',
            action: 'ok'
          },
          {
            label: '취소',
            action: 'cancel'
          }
        ]
      },

      form: {
        field_name:'',
        writer:'',
        company:'',
        occur_type:'', //발행구분
        occur_date:'', //요청일
        require:'', // 요구사항
        action_date:'', //조치일
        actionList:[],
        /*
        actionContent:'',
        actionResult:'',
        before:{},
        after:{}
         */
        preview:{
          field_name:'', //현장
          occur_type:'', //발행구분
          company:'', //파트너사
          writer:'', //작성자
          occur_date:'', //요청일
          action_date:'' //조치일
        }
      },
      fileList: [], // 파일 리스트
      oldForm:{},

      after:[],
      postAfters:{},
      isShowApproval:false,
    }
  },

  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {

      if (JSON.stringify(this.oldForm) === JSON.stringify(this.form)) {
        next(true)
      } else if (confirm('저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?')) {
        next(true)
      }

    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },

  created () {

    this.loadPost()
  },

  methods:{
    async loadPost () {

      // 내용불러오기
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {
        boardSlug,
        postId
      })

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      this.postAfters = this.$store.state.approval.postAfters
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post

      const files = this.$store.state.approval.postInfo.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !(this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
      this.approvalLine = doc.line.slice() // api 전송용

      this.oldForm = JSON.parse(JSON.stringify(this.form))

      if (this.board.statusCode === 'approved' && this.form.actionList) {
        this.after = []
        for (let i = 0; i < this.form.actionList.length; i++) {
          this.after.push({
            text:'',
            attach:{},

          })
        }

        if (this.postAfters.length > 0) {
          const list = JSON.parse(this.postAfters[0].after_content)
          this.after = list
        }
      }
    },

    async register (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }

      const projectId = this.$route.params.proj_id
      const boardSlug = this.boardSlug
      const title = this.form.field_name
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      const postId = this.$route.params.postId

      let uploads = ''
      const listUploads = []
      const uploadFileIds = []

      if (this.fileList.length > 0) {
        for (const file of this.fileList) {
          listUploads.push(file)
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }
      this.form.preview.attach = JSON.stringify(listUploads)

      this.form.preview.hse_type = this.form.hse_type
      this.form.preview.field_name = this.form.field_name
      this.form.preview.occur_type = this.form.occur_type
      this.form.preview.company = this.form.company
      this.form.preview.writer = this.form.writer
      this.form.preview.occur_date = this.form.occur_date
      this.form.preview.action_date = this.form.action_date
      const content = JSON.stringify(this.form)

      try {
        if (isUploaded) {
          // 바로 상신하기
          const unTemp = 'y'
          await this.$store.dispatch('approval/UPDATE_POST', {
            projectId,
            boardSlug,
            postId,
            title,
            content,
            approvalLine,
            uploads,
            unTemp
          })
          alert('상신되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.$router.back()
        } else {
          // 임시 저장하기
          const unTemp = 'n'
          await this.$store.dispatch('approval/UPDATE_POST', {
            projectId,
            boardSlug,
            postId,
            title,
            content,
            approvalLine,
            uploads,
            unTemp
          })
          alert('임시저장되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.$router.back()
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
          console.log(this.$store.state.approval.error_code)
        }
      }

    },

    async reRegister () {
      if (!this.approvalLine || this.approvalLine.length === 0) {
        alert('결재선을 지정해주세요')
        return
      }

      const projectId = this.$route.params.proj_id
      const boardSlug = this.boardSlug
      const title = this.form.field_name
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      const security = 'normal' // 문서보안 등급 ['일반', 대외비 1급, 대외비 2급, 인비, 극비] [normal,confidential1,confidential2,personally,confidential0]
      const priority = 'medium' // 문서 중요도 [매우낮음, 낮음, 보통, 높음, 매우 높음] [lowest,low,medium,high,highest]

      let uploads = ''
      const listUploads = []
      const uploadFileIds = []

      if (this.fileList.length > 0) {
        for (const file of this.fileList) {
          listUploads.push(file)
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }
      this.form.preview.attach = JSON.stringify(listUploads)

      this.form.preview.field_name = this.form.field_name
      this.form.preview.occur_type = this.form.occur_type
      this.form.preview.company = this.form.company
      this.form.preview.writer = this.form.writer
      this.form.preview.occur_date = this.form.occur_date
      this.form.preview.action_date = this.form.action_date
      const content = JSON.stringify(this.form)

      try {
        // 임시 저장하기
        const isTemp = 1
        await this.$store.dispatch('approval/CREATE_POST', {
          projectId, boardSlug, title, content, approvalLine, security, priority, uploads, isTemp
        })
        alert('임시저장되었습니다.')
        this.oldForm = JSON.parse(JSON.stringify(this.form))
        this.$router.back()
      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
        } else {
          console.log(this.$store.state.approval.error_code)
        }
      }

    },

    // TODO : 얼럿데이터
    async alertOk () {

      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {
        postId
      })

      this.oldForm = JSON.parse(JSON.stringify(this.form))
      document.location.reload()
    },

    async alertNo (text) {
      const postId = this.$route.params.postId
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', {
        postId,
        comment
      })

      this.oldForm = JSON.parse(JSON.stringify(this.form))
      document.location.reload()
    },

    formCheck () {
      if (this.form.occur_type.trim().length <= 0) {
        alert('발생구분을 선택하세요')
        return false
      } else if (this.form.occur_date.trim().length <= 0) {
        alert('발생일을 선택하세요')
        return false
      } else if (this.form.action_date.trim().length <= 0) {
        alert('조치일를 선택하세요')
        return false
      } else if (this.form.require.trim().length <= 0) {
        alert('시정 및 예방조치 요구사항을 입력하세요')
        return false
      }
      return true
    },

    alertUpload () {
      this.register(true)
    },

    handleClickAddEval () {

      this.form.actionList.push({
        is_checked: false,
        actionContent:'',
        actionResult:'',
        before:{},
        after:{}
      })
    },

    handleClickRemoveEval () {
      for (let i = 0; i < this.form.actionList.length; i++) {
        if (this.form.actionList[i].is_checked) {
          this.form.actionList.remove(this.form.actionList[i])
          i = -1
        }
      }
    },

    // 글 삭제
    async handleDeletePost () {
      if (confirm('삭제하시겠습니까?')) {
        const boardSlug = this.boardSlug
        const postId = this.$route.params.postId
        await this.$store.dispatch('approval/DELETE_POST', {boardSlug, postId})
        this.oldForm = this.form
        this.$router.back()
      }
    },

    handleBackMenu () {
      this.$emit('handleBackMenu', 'safety')
    },

    handleClickUpdate () {
      if (confirm('저장하시겠습니까?')) {
        this.register(false)
      }
    },

    handleClickCollection () {
      if (confirm('회수 후 임시저장 상태로 변경하시겠습니까?')) {
        this.register(false)

      }
    },

    handleClickRegister () {
      if (confirm('임시저장 하시겠습니까?')) {
        this.reRegister(false)
      }
    },

    handleClickUpload () {
      if (confirm('상신하시겠습니까?')) {
        this.register(true)
      }

    },

    // ApprovalProcessModule 에서 사용하는 line 방식에서 전송용 line 으로 변경
    lineToSendLine (data) {
      const approvalList = []

      for (const member of data) {
        if (member.type_code !== 'register') {
          approvalList.push({
            id: member.user_id,
            name: member.user_name,
            elementType: member.type_code
          })
        }
      }
      return approvalList
    },

    handleSendApprovalProcess (approvalLine) {
      this.approvalLine = approvalLine
    },

    handleClickNo () {
      this.alert.html = '<p>반려하시겠습니까?</p><p>아래에 사유를 작성해주세요.</p>'
      this.alert.message = ''
      this.alert.isConfirm = true
      this.alert.buttons = [
        {
          label: '반려',
          action: 'no'
        },
        {
          label: '취소',
          action: 'cancel',
          type: 'border'
        }
      ]
      this.alert.show = true
    },
    async handleClickOk () {
      this.alert.html = ''
      this.alert.message = '승인하시겠습니까?'
      this.alert.isConfirm = false
      this.alert.buttons = [
        {
          label: '승인',
          action: 'ok'
        },
        {
          label: '취소',
          action: 'cancel',
          type: 'border'
        }
      ]
      this.alert.show = true

    },

    async handleClickAfterData () {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      const content = JSON.stringify(this.after)

      if (this.$store.state.approval.postAfters.length > 0) {
        const afterId = this.postAfters[0].id
        await this.$store.dispatch('approval/UPDATE_AFTER_DATA', {
          content,
          boardSlug,
          postId,
          afterId
        })
      } else {
        const content = [JSON.stringify(this.after)]
        await this.$store.dispatch('approval/ADD_AFTER_DATA', {
          content,
          boardSlug,
          postId
        })
      }

      document.location.reload()
    },

    showApproval () {
      this.isShowApproval = true
    },

    hideApproval () {
      this.isShowApproval = false
    },

    back () {
      this.$router.back()
    },
  }
}
</script>

<style scoped>
.pointout:nth-child(2n+1) {
  background: #fafafa;
}
</style>
